import React from 'react';
import { errorTypeMeta, ErrorType } from '@util/enums';
import { ErrorBox, ErrorPage } from '@styled/Page';
import FSButton from '@components/FSButton';
function ErrorScreen(props) {
    var _a = props.type, type = _a === void 0 ? ErrorType.NOT_FOUND : _a;
    var _b = errorTypeMeta[type], code = _b.code, title = _b.title, description = _b.description, returnButtonText = _b.returnButtonText, fn = _b.fn;
    return (React.createElement(ErrorPage, null,
        React.createElement(ErrorBox, null,
            code ? React.createElement("h1", null, code) : null,
            React.createElement("h2", null, title),
            React.createElement("p", null, description),
            React.createElement(FSButton, { "$type": "secondary", onClick: function () { return fn(); }, title: returnButtonText, style: { marginTop: 10 } }))));
}
export default ErrorScreen;
